import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Tenant/Navbar";
import Sidebar from "../../../components/Tenant/Sidebar";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import NotFound from "../../../components/NotFound";
import "../tenant.css";
import Footer from "../../../components/Tenant/Footer";
import Temp from "../Temp/Temp";
import Profile from "../Profile/Profile";
import ProductList from "../Product/ProductList";
import AddProduct from "../Product/AddProduct";
import QrGeneration from "../QrCode/QrGeneration";
import EditProduct from "../Product/EditProduct";
import QrPrint from "../QrCode/QrPrint";
import ProductHeirarchy from "../Product/ProductHeirarchy";
import BatchList from "../Batch/BatchList";
import AddBatch from "../Batch/AddBatch";
import QrByBatch from "../QrCode/QrByBatch";
import GiftList from "../Gift/GiftList";
import AddGift from "../Gift/AddGift";
import GiftCatalogueList from "../GiftCatalogue/GiftCatalogueList";
import GiftCatalogue from "../GiftCatalogue/GiftCatalogue";
import AddGiftCatalogue from "../GiftCatalogue/AddGiftCatalogue";
import UserList from "../UserList/UserList";
import DistributorWiseScanning from "../DistributorWiseScanning/DistributorWiseScanning";
import DistributorRetailerMapping from "../DistributorWiseScanning/DistributorRetailerMapping";
import UserScanHistory from "../UserScanHistory/UserScanHistory";
import ProductPoints from "../Rewardify/ProductPoints/ProductPoints";
import AddProductPoints from "../Rewardify/ProductPoints/AddProductPoints";
import PointsHistory from "../Rewardify/PointsHistory/PointsHistory";
import RedeemRequest from "../RedeemRequest/RedeemRequest";
import IssueReport from "../IssueReport/IssueReport";
import Video from "../MediaCommunication/Video/Video";
import Gallery from "../MediaCommunication/Gallery/Gallery";
import BannerList from "../MediaCommunication/Banner/BannerList";
import UserProfile from "../UserProfile/UserProfile";
import BrandList from "../Brands/BrandList";
import ECatalogue from "../MediaCommunication/E_Catalogue/ECatalogue";
import AddECatalogue from "../MediaCommunication/E_Catalogue/AddECatalogue";
import { useGetAppUserTypesMutation } from "../../../features/tenant/appUsers/appUsersApi";
import WebPanelUsers from "../WebPanelUsers/WebPanelUsers";
import AddWebPanelUser from "../WebPanelUsers/AddWebPanelUser";
import WebPanelRoles from "../WebPanelRoles/WebPanelRoles";
import EditWebPanelRolePermission from "../WebPanelRoles/EditWebPanelRolePermission";
import Wheel from "../Wheel/Wheel";
import WheelCampaign from "../Wheel/WheelCampaign";
import AddWheel from "../Wheel/AddWheel";
import ManageCouponProvider from "../Rewardify/CouponMaster/ManageCouponProvider";
import StaticCouponsList from "../Rewardify/CouponMaster/StaticCouponsList";
import AddStaticCoupon from "../Rewardify/CouponMaster/AddStaticCoupon";
import CouponByBrand from "../Rewardify/CouponMaster/CouponByBrand";
import RedeemedCouponList from "../Rewardify/CouponMaster/RedeemedCouponList";
import DynamicCoupon from "../Rewardify/CouponMaster/DynamicCoupon";
import AddDynamicCoupon from "../Rewardify/CouponMaster/AddDynamicCoupon";
import DistinctQrScanHistory from "../DistinctQrScanHistory/DistinctQrScanHistory";

import PayementGateway from "../PaymentGateway/PayementGateway";
import AddPaymentGateway from "../PaymentGateway/AddPaymentGateway";
import WheelCampaignList from "../Wheel/WheelCampaignList";
import AppUserType from "../AppUserType/AppUserType";
import WheelSummary from "../Wheel/WheelSummary";
import WarrantyList from "../Warranty/WarrantyList";
import WarrantyOnProducts from "../WarrantyOnProducts/WarrantyOnProducts";
import AddWarrantyOnProducts from "../WarrantyOnProducts/AddWarrantyOnProducts";
import GalleryList from "../MediaCommunication/Gallery/GalleryList";
import VideoList from "../MediaCommunication/Video/VideoList";
import CreateSalesBooster from "../SalesBooster/CreateSalesBooster";
import SalesBoosterList from "../SalesBooster/SalesBoosterList";
import Campaign from "../Campaign/Campaign";
import AddCampaign from "../Campaign/AddCampaign";
import ViewCampaign from "../Campaign/ViewCampaign";
import ReferAndEarnRewards from "../ReferAndEarnRewards/ReferAndEarnRewards";
import AddReferralAndEarnRewards from "../ReferAndEarnRewards/AddReferralAndEarnRewards";
import LeaderBoard from "../LeaderBoard/LeaderBoard";
import ManageSalesBooster from "../SalesBooster/ManageSalesBooster";
import SMSCredential from "../SMSMaster/SMSCredential";
import AddSMSCredential from "../SMSMaster/AddSMSCredential";
import CouponCredential from "../CouponMaster/CouponCredential";
import AddCouponCredential from "../CouponMaster/AddCouponCredential";
import SMSTemplates from "../SMSMaster/SMSTemplates";
import AddSMSTemplates from "../SMSMaster/AddSMSTemplates";
import EditProfile from "../Profile/EditProfile";
import WarrantyClaimList from "../Warranty/WarrantyClaimList";
import EmailCredentials from "../EmailMaster/EmailCredentials";
import ManageEmailCredentials from "../EmailMaster/ManageEmailCredential";
import EmailTemplates from "../EmailMaster/EmailTemplates";
import ManageEmailTemplate from "../EmailMaster/ManageEmailTemplate";
import ErrorLogs from "../ErrorLogs/ErrorLogs";
import SchemeList from "../Scheme/SchemeList";
import ManageScheme from "../Scheme/ManageScheme";
import AddMembership from "../Membership/AddMembership";
import ManageMembership from "../Membership/ManageMembership";
import MembershipList from "../Membership/MembershipList";
import DreamGiftsRedeemRequest from "../dreamGifts/DreamGiftsRedeemRequest";
import AddScaratchableScheme from "../Scratchable Coupon Scheme/AddScaratchableScheme";
import ScratchableRewards from "../Scratchable Coupon Scheme/ScratchableRewards";
import ScratchableRewardList from "../Scratchable Coupon Scheme/ScractableRewardList";
import ScratchableSchemeList from "../Scratchable Coupon Scheme/ScratchableSchemeList";
import PurchaseOrderList from "../PurchaseOrder/PurchaseOrderList";
import ManagePurchaseOrder from "../PurchaseOrder/ManagePurchaseOrder";
import UpdatePurchaseOrder from "../PurchaseOrder/UpdatePurchaseOrder";
import SchemePurchaseOrders from "../Scratchable Coupon Scheme/SchemePurchaseOrders";
import AddRewardScheme from "../RewardScheme/AddRewardScheme";
import LuckyDrawSetup from "../RewardScheme/LuckyDrawSetup";
import AllRewardSchemeList from "../RewardScheme/AllRewardSchemeList";
import SchemeOrderUpload from "../RewardScheme/SchemeOrderUpload";
import Zones from "../Zones/Zones";
import AddZones from "../Zones/AddZones";
import ShelfVisibility from "../ShelfVisibility/ShelfVisibility";
import ViewLocations from "../Zones/ViewLocations";
import AppOtps from "../AppOtps/AppOtps";
import ErrorBoundry from "../../../components/ErrorBoundry/ErrorBoundry";
import LegalList from "../Legal/LegalList";
import AddLegal from "../Legal/AddLegal";
import Mediaist from "../MediaCommunication/Media/MediaList";
import Tracking from "../Tracking/Tracking";
import AppBan from "../AppBan/AppBan";
import SupportQueries from "../SupportQueries/SupportQueries";
import BankList from "../BankList/BankList";
import TDS from "../TDS/TDS";
import Notification from "../Notification/Notification";
import NotificationHistory from "../Notification/NotificationHistory";
import QrBatchImport from "../Ozone/QrBatchImport";
import CashTransactionList from "../CashTransactions/CashTransactionList";
import PaymentTransferList from "../PaymentTransfer/PaymentTransferList";
import PaymentTransferListByBatchId from "../PaymentTransfer/PaymentTransferListByBatchId";
import UploadPaymentTransfer from "../PaymentTransfer/UploadPaymentTransfer";
import Faq from "../Faqs/Faq";
import AddFaq from "../Faqs/AddFaq";
import UpdateFaq from "../Faqs/UpdateFaq";
import ProductInstallationVideo from "../ProductInstallationVideo/ProductInstallationVideo";
import WhatsappNotificationCredentials from "../WhatsappNotification/WhatsappNotificationCredentials";
import AddWhatsappNotificationCredential from "../WhatsappNotification/AddWhatsappNotificationCredential";
import WhatsappNotificationTemplates from "../WhatsappNotification/WhatsappNotificationTemplates";
import AddWhatappNotificationTemplates from "../WhatsappNotification/AddWhatappNotificationTemplates";
import PushNotificationsTypeList from "../MediaCommunication/PushNotifications/PushNotifcationsTypeList";
import AddPushNotificationsType from "../MediaCommunication/PushNotifications/AddPushNotificationsType";
import LoggingWhatsappAndSMS from "../LoggingWhatsappAndSMS/LoggingWhatsappAndSMS";
import QrBulkUpload from "../QrCode/QrBulkUpload";
import PushNotificationsDumpList from "../MediaCommunication/PushNotifications/PushNotificationDumpList";
import BookAppointment from "../BookAppointment/BookAppointment";
import QrMapping from "../QrCode/QrMapping";
import CashTransferRequests from "../CashTransferRequests/CashTransferRequests";
import AllQrCodeList from "../QrCode/AllQrCodeList";
import ExtraPointHistory from "../Rewardify/PointsHistory/ExtraPointHistory";
import MembershipHistory from "../Membership/MembershipHIstory";
import PrintersList from "../Printer/AllPrinters";
import AddPrinter from "../Printer/AddPrinter";
import CouponRequests from "../Rewardify/CouponMaster/couponRequest";
import OzoneDynamicCouponList from "../Ozone/OzoneDynamicCouponList";
import DynamicCouponRequestList from "../Ozone/DynamicCouponRequestList";
import UploadOrders from "../Modenik/UploadOrders";
import AllOrderList from "../Modenik/AllOrderList";
import AppFeedback from "../AppFeedBack/AppFeedBack";
import NotInitiatedPayment from "../NotInitiatePayment/NotInitiatedPayment";
import ActiveUsers from "../ActiveUsers/ActiveUsers";
import PointsHistoryRetailers from "../Rewardify/PointsHistory/PointsHistoryRetailers";
import UploadPaymentTarget from "../PaymentTarget/UploadPaymentTarget";
import PaymentTargetListByBatchId from "../PaymentTarget/PaymentTargetListByBatchId";
import PaymentTargetList from "../PaymentTarget/PaymentTargetList";
import UserRolesSupplyBean from "../SupplyBeam/UserRolesSupplyBeam/UserRolesSupplyBean";
import EditUserRolesPermissionSupplyBeam from "../SupplyBeam/UserRolesSupplyBeam/EditUserRolesPermissionSupplyBeam";
import SupplyBeamUsers from "../SupplyBeam/ManageSupplyBeamUsers/SupplyBeamUsers";
import AddSupplyUsers from "../SupplyBeam/ManageSupplyBeamUsers/AddSupplyUsers";
import AddSiteLocations from "../SupplyBeam/SiteLocationsSupplyBeam/AddSiteLocations";
import SiteLocation from "../SupplyBeam/SiteLocationsSupplyBeam/SiteLocation";
import QrTracking from "../SupplyBeam/QrTracking/QrTracking";
import SearchByBatchRunningCode from "../QrCode/SearchByBatchRunningCode";
import VerificationRecords from "../VerificationRecords/VerificationRecords";
import AppVersion from "../AppVersion/AppVersion";
import AllUsersList from "../AllUsersList/AllUsersList";
import UnEnteredProducts from "../Ozone/UnAddedProductList";
import ManualRewarding from "../ManualRewarding/ManualRewarding";
import SendBulkMessages from "../SendBulkMessages/SendBulkMessages";
import RequestProjectQuotation from "../Ultimatrue/RequestProjectQuotation";
import Home from "../Home/Home";
import BulkManualRewarding from "../ManualRewarding/BulkManualRewarding";
import UserMapping from "../Mapping/UserMapping";
import FirebaseTopicsList from "../FirebaseTopics/FirebaseTopicsList";
import CustomNotifications from "../CustomNotifications/CustomNotifications";
import AddCustomNotifications from "../CustomNotifications/AddCustomNotifications";
import NotificationTemplate from "../NotificationTemplate/NotificationTemplate";
import AddNotificationTemplate from "../NotificationTemplate/AddNotificationTemplate";
import NotificationRule from "../NotificationRule/NotificationRule";
import AddNotificationRule from "../NotificationRule/AddNotificationRule";
import AccountTransfer from "../AccountTransfer/AccountTransfer";
import AccountTransferList from "../AccountTransfer/AccountTransferList";
import QrDistributorMapping from "../JqrSports/QrDistributorMapping";
import SchemeDetailsList from "../Scheme/SchemeDetails";
import SchemeWalletList from "../Scheme/SchemeWalletList";
import CreateSchemeWizard from "../Scheme/CreateSchemeWizard";
import CgGenerateQr from "../ClientSpecific/CgGenerateQr";
import PointHistoryJqr from "../JqrSports/PointHistoryJqr";
import UltimatrueUserList from "../Ultimatrue/UltimatrueUserList";
import RemovedUsers from "../RemovedUsers/RemovedUsers";
import JqrUserList from "../JqrSports/JqrUserList";
import JqrUserProfile from "../JqrSports/JqrUserProfile";
import WebFeedback from "../WebFeedback/WebFeedback";
import UltimatrueUserProfile from "../Ultimatrue/UltimatrueUserProfile";
import TdsOnRedemptions from "../TDSOnRedemptions/TdsOnRedemptions";
import GullakPointsUpload from "../Modenik/GullakPointsUpload";
import GullakPoints from "../Modenik/GullakPoints";
import LoggingWhatsapp from "../LoggingWhatsapp/LoggingWhatsapp";
import JqrDashboard from "../JqrSports/JqrDashboard";
import QrProductMapping from "../QrMapping/QrMapping";
import BanUnban from "../BanUnban/BanUnban";
import UpdateQrList from "../UpdateQr/UpdateQrList";
import DreamGiftsStatus from "../dreamGifts/DreamGiftsStatus";
import CustomerDataList from "../Ultimatrue/CustomerDataList";
import OrderUpload from "../Order/OrderUpload";
import AppUsersScan from "../Aqualite/AppUsersScan";
import PanelQrPrint from "../PanelUserPages/PanelQrPrint";
import PanelAllQrCodeList from "../PanelUserPages/PanelAllQrCodeList";
import QrReport from "../QrReport/QrReport";
import CheckoutList from "../../SupplyBeam/CheckoutList/CheckoutList";
import CheckinList from "../../SupplyBeam/CheckoutList/CheckinList";
import AgricultureUsersList from "../AgricultureUsersList/AgricultureUsersList";
import FootwearUsersList from "../FootWearUsersList/FootwearUsersList";
import HardwareUsersList from "../HardwareUsersList/HardwareUsersList";
import HoseiryUsersList from "../HosieryUsersList/HoseiryUsersList";
import UserProductMapping from "../VendorProduct/VendorProductUsers";
import QrSyncStats from "../Aqualite/QrSyncStats";
import QrSyncStatsByBatch from "../Aqualite/QrSyncStatsByBatch";
import AqualiteInvoices from "../Aqualite/AqualiteInvoices";
import ReassignWarrantyList from "../Warranty/ReassignWarrantyList";
import ReturnList from "../../SupplyBeam/inventory/ReturnList";
import ReturnInfo from "../../SupplyBeam/inventory/ReturnInfo";
import UserTypeChangeList from "../UserTypeChange/UserTypeChange";
import UltimatrueSellDetails from "../ClientSpecific/UltimaTrueSellDetails";
import LancerQrGeneration from "../ClientSpecific/LancerGenerateQr";
import SalesBoosterHistoryBorosil from "../Borosil/SalesBoosterHistoryBorosil";
import SalesBoosterHistory from "../SalesBooster/SalesBoosterHistory";
import BulkExtraPoints from "../BulkExtraPoints/BulkExtraPoints";
import UsersPointSummary from "../Borosil/BorosilUserPointSummary";
import MonthWisePointSummary from "../Borosil/MonthWisePointSummary";
import UserListBorosil from "../Borosil/UserListBorosil";
import ModenikExtraPoints from "../Modenik/ModenikExtraPoints";
import ModenikMapping from "../Modenik/ModenikMapping";
import RedemptionsList from "../RedeemRequest/RedemptionsList";
import ModenikPointSummary from "../Modenik/ModenikPointSummary";
import AppProductFeedBack from "../AppProductFeedback/AppProductFeedBack";
import OrderSummary from "../OrderSummary/OrderSummary";
import OrderDetail from "../OrderSummary/OrderDetail";
import OrderList from "../OrderList/OrderList";
import TableauDashboard2 from "../../../components/TableauDashboard/TableauDashboard2";
import QrMappingToUser from "../QrMapping/QrMappingToUser";
import BorosilExtraPoints from "../Borosil/BorosilExtraPoints";
import BorosilOrderList from "../Borosil/BorosilOrderList";
import BorosilUserHistorySearch from "../Borosil/BorosilUserHistorySearch";
import BorosilBulkSms from "../Borosil/BorosilBulkSms";
import ReferUser from "../ReferUser/ReferUser";
import SkuProductMap from "../SkuProductMap/SkuProductMap";
import AddSkuProductMap from "../SkuProductMap/AddSkuProductMap";
import AllMappedQrsList from "../QrCode/AllMappedQrsList";
import SeedworksQrGeneration from "../ClientSpecific/SeedworksGenerateQr";
import EditECatalogue from "../MediaCommunication/E_Catalogue/EditECatalogue";
import AppLogins from "../AppLogins/AppLogins";
import BikajiOrderList from "../ClientSpecific/BikajiIOrderList";
import BikajiIShelfList from "../ClientSpecific/BikajiIShelfList";
import CavinDailyData from "../ClientSpecific/CavinDailyData";
import BchDailyReport from "../ClientSpecific/BchDailyReport";
import CavinMonthlyData from "../ClientSpecific/CavinMonthlyData";
import DistributorWisePointInfo from "../SupplyBeam/customPages/DistributorWisePointInfo";
import MandatoryFieldsView from "../MandatoryFields/MandatoryFields";
import KycUpdate from "../KycUpdate/KycUpdate";
import SiyaramSalesUsers from "../ClientSpecific/SiyaramSalesUsers";
import SiyaramEmpSalesUsers from "../ClientSpecific/SiyaramEmpSalesUsers";
import TenantSlugs from "../../../utils/TenantSlug";
import ParticipatingBrand from "../ParticipatingBrand/ParticipatingBrand";
import BikajiOrderLedger from "../ClientSpecific/BikajiOrderLedger";
import FreezeQrs from "../QrCode/freezeQrs";
import ManageSchemeTier from "../Scheme/ManageTier";
import AllGverifyQrCodeList from "../QrCode/AllGverifyQrCodeList";
import OrderErrorLogs from "../Order/OrderErrorLogs";
import CartonList from "../SupplyBeam/customPages/cartonList";
import CartonChildList from "../SupplyBeam/customPages/CartonChildList";
import UserLogsList from "../UserLogs/UserLogsList";
import AqualitePendingUser from "../ClientSpecific/AqualitePendingUser";
import EmployeeList from "../EmployeeHierarchy/EmployeeList/EmployeeList";
import EmployeeLevel from "../EmployeeHierarchy/EmployeeLevel/EmployeeLevel";
import EditAssortment from "../SupplyBeam/customPages/editAssortment";
import ZoneLoc from "../EmployeeHierarchy/ZoneLoc/ZoneLoc";
import EcommerceHeirarchy from "../EcommerceProduct/EcommerceHeirarchy";
import AdminApprovalList from "../lotus/adminApprovalList";
import ApprovalList from "../lotus/approvalList";
import GautamGarmentsBulkSms from "../GautamGarments/GautamGarmentsBulkSms";
import ZonePincodeMapping from "../EmployeeHierarchy/ZoneLoc/ZonePincodeMapping";
import DeleteQr from "../QrCode/deleteQr";
import PendingQrs from "../PendingQrs/PendingQrs";
import CommunityList from "../Community/CommunityList";
import RulesList from "../Rules/RulesList";
import CacheManagement from "../CacheManagement/CacheManagement";
import RuleBuilderPage from "../Rules/RuleBuilderPage";
import ViewRule from "../Rules/ViewRule";
import RuleAnalyticsScreen from "../Rules/RuleAnalytics";
import SchemeScanningHistory from "../SchemeScanningHistory/SchemeScanningHistory";
import UserTypeSchemeList from "../UserTypeSchemeList/UserTypeSchemeList";
import HelpAndSupport from "../lotus/helpAndSupport";
import EcommerceProductList from "../EcommerceProduct/EcommerceProductList";
import AddEcommerceProduct from "../EcommerceProduct/AddEcommerceProduct";
import EditEcommerceProduct from "../EcommerceProduct/EditEcommerceProduct";
import EcommerceSizeMaster from "../EcommerceProduct/EcommerceSizeMaster";
import EcommerceColorMaster from "../EcommerceProduct/EcommerceColorMaster";
import EcommerceInventory from "../EcommerceProduct/EcommerceInventory";
import EcommerceOrderList from "../EcommerceOrder/EcommerceOrderList";
import EcommerceOrderDetail from "../EcommerceOrder/EcommerceOrderDetail";
import EcommerceImages from "../EcommerceImages/EcommerceImages";
import CenturyLedger from "../CenturyLedger/CenturyLedger";
import CenturyAuditTrail from "../CenturyAuditTrail/CenturyAuditTrail";
import CenturyExpiryPoints from "../CenturyExpiryPoints/CenturyExpiryPoints";
import QuizList from "../Quiz/QuizList";
import AddEditQuiz from "../Quiz/AddEditQuiz";

import WheelRewardsWon from "../Wheel/WheelRewardsWon.jsx";
import AllCheckInQrList from "../QrCode/AllCheckInQrList";
import WheelList from "../Wheel/wheelList";
import ExportReports from "../ExportReports/ExportReports.jsx";
import QrGenerationTalbros from "../QrCode/talbrosQrGeneration.jsx";
import PrinterTempelateMapping from "../Printer/PrinterTempelateMapping.jsx";
import BulkScanHistory from "../BulkScanHistory/BulkScanHistory";
import QrScanTimeline from "../QrScanTimeline/QrScanTimeline";
import TableauDashboardSales from "../../../components/TableauDashboard/TableauDashboardSales.jsx";
import WalletTransfer from "../WalletTransfer/WalletTransfer";
import WalletTransferLogs from "../WalletTransfer/WalletTransferLogs";
import WalletTransferBatchDetails from "../WalletTransfer/WalletTransferBatchDetails";
import ApprovalWorkflow from "../ApprovalWorkflow/ApprovalWorkflow";
import ApprovalRequests from "../ApprovalRequests/ApprovalRequests";
import ViewStats from "../Scheme/ViewStats";
import UserSessionMetrics from "../ActiveUsers/UserSessionMetrics";
import BanStateAtScanning from "../QrCode/BanQrByState.jsx";
import TrackQrHistory from "../TrackQrHistory/TrackQrHistory";
import BorosilRankRules from "../Borosil/BorosilRankRules";
import BontonParentQrGeneration from "../QrCode/BontonQrParentGeneration.jsx";
import BontonChildQrGeneration from "../QrCode/BontonQrChildGeneration.jsx";
import BorosilRedemptionHistory from "../Borosil/BorosilRedemptionHistory.jsx"
import PicklistList from "../../SupplyBeam/BontonListing/PicklistList.jsx";
import InvoiceList from "../../SupplyBeam/BontonListing/InvoiceList.jsx";
import BontonOrderList from "../../SupplyBeam/BontonListing/OrderList.jsx";
import MappedList from "../../SupplyBeam/BontonMapping/MappedList.jsx";
import DemappedList from "../../SupplyBeam/BontonMapping/DemappedList.jsx";
// import BorosilRedemptionHistory from "../Borosil/BorosilRedemptionHistory.jsx"
import BontonQrTracking from "../SupplyBeam/QrTracking/BontonQrTracking.jsx";
import IffcoReports from "../ClientSpecific/IffcoReports.jsx";
import IffcoExpiryAgeing from "../ClientSpecific/IffcoExpiryAgeing.jsx";
import IffcoRetailerInventory from "../ClientSpecific/IffcoRetailerInventory.jsx";
import IffcoScanActivityLog from "../ClientSpecific/IffcoScanActivityLog.jsx";
import IffcoRetailerCoverage from "../ClientSpecific/IffcoRetailerCoverage.jsx";
import IffcoUnscannedQrs from "../ClientSpecific/IffcoUnscannedQrs.jsx";


const TenantHome = () => {
  const [
    getAppUserTypes,
    { data: getAppUserTypesData, error: getAppUserTypesError },
  ] = useGetAppUserTypesMutation();

  useEffect(() => {
    const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
    if (!appUserTypes) {
      getAppUserTypes({
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      });
    }
  }, []);

  useEffect(() => {
    if (getAppUserTypesData) {
      sessionStorage.setItem(
        "appUserType",
        JSON.stringify(getAppUserTypesData.body),
      );
    }
  }, [getAppUserTypesData]);

  const [isOpen, setIsopen] = useState(true);

  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  useEffect(() => {
    // Function to check the window size and set sidebar visibility
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsopen(false);
      } else {
        setIsopen(true);
      }
    };

    // Initial check
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="flex">
      <Sidebar isOpen={isOpen} />
      <div className="flex flex-col flex-1 withrgt ">
        <Navbar togglesidebar={ToggleSidebar} />
        <Routes>
          <Route
            exact
            path=""
            element={
              <ErrorBoundry>
                <Home />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/track-qr-history"
            element={
              <ErrorBoundry>
                <TrackQrHistory />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/bulk-scan-history"
            element={
              <ErrorBoundry>
                <BulkScanHistory />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/qr-scan-timeline"
            element={
              <ErrorBoundry>
                <QrScanTimeline />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wallet-transfer"
            element={
              <ErrorBoundry>
                <WalletTransfer />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wallet-transfer-logs"
            element={
              <ErrorBoundry>
                <WalletTransferLogs />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wallet-transfer-details/:batch_id"
            element={
              <ErrorBoundry>
                <WalletTransferBatchDetails />
              </ErrorBoundry>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ErrorBoundry>
                <Dashboard />
              </ErrorBoundry>
            }
          />

          <Route
            path="/dashboard/tableau"
            element={
              <ErrorBoundry>
                <TableauDashboard2 />
              </ErrorBoundry>
            }
          />
          <Route
            path="/dashboard/sales"
            element={
              <ErrorBoundry>
                <TableauDashboardSales />
              </ErrorBoundry>
            }
          />

          <Route
            path="/stats"
            element={
              <ErrorBoundry>
                <JqrDashboard />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/profile"
            element={
              <ErrorBoundry>
                <Profile />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/profile/edit"
            element={
              <ErrorBoundry>
                <EditProfile />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/product/heirarchy"
            element={
              <ErrorBoundry>
                <ProductHeirarchy />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/active-users"
            element={
              <ErrorBoundry>
                <ActiveUsers />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/user-sessions-metrics"
            element={
              <ErrorBoundry>
                <UserSessionMetrics />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/product"
            element={
              <ErrorBoundry>
                <ProductList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/product/add"
            element={
              <ErrorBoundry>
                <AddProduct />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/product/edit/:product_id"
            element={
              <ErrorBoundry>
                <EditProduct />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/product-points"
            element={
              <ErrorBoundry>
                <ProductPoints />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/product-points/add"
            element={
              <ErrorBoundry>
                <AddProductPoints />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/batch"
            element={
              <ErrorBoundry>
                <BatchList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/batch/add"
            element={
              <ErrorBoundry>
                <AddBatch />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/generateQr"
            element={
              <ErrorBoundry>
                <QrGeneration />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/generateParentQr"
            element={
              <ErrorBoundry>
                <BontonParentQrGeneration />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/generateChildQr"
            element={
              <ErrorBoundry>
                <BontonChildQrGeneration />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/generatetalbrosQr"
            element={
              <ErrorBoundry>
                <QrGenerationTalbros />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/cgqr"
            element={
              <ErrorBoundry>
                <CgGenerateQr />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/footwearqr"
            element={
              <ErrorBoundry>
                <LancerQrGeneration />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/seedworkqr"
            element={
              <ErrorBoundry>
                <SeedworksQrGeneration />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/upload-qr"
            element={
              <ErrorBoundry>
                <QrBulkUpload />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/printQr"
            element={
              <ErrorBoundry>
                <QrPrint />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/panel-printQr"
            element={
              <ErrorBoundry>
                <PanelQrPrint />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/skuProductMap"
            element={
              <ErrorBoundry>
                <SkuProductMap />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/skuProductMap/add"
            element={
              <ErrorBoundry>
                <AddSkuProductMap />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/printQrList"
            element={
              <ErrorBoundry>
                <AllQrCodeList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/freezeQrList"
            element={
              <ErrorBoundry>
                <FreezeQrs />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/gverifyQrList"
            element={
              <ErrorBoundry>
                <AllGverifyQrCodeList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/printCheckoutQrList"
            element={
              <ErrorBoundry>
                <AllMappedQrsList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/supply-beam-users"
            element={
              <ErrorBoundry>
                <SupplyBeamUsers />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/supply-beam-users/add"
            element={
              <ErrorBoundry>
                <AddSupplyUsers />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/supplyBeam/qr-location"
            element={
              <ErrorBoundry>
                <BontonQrTracking />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/printCheckinQrList"
            element={
              <ErrorBoundry>
                <AllCheckInQrList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/panel-printQrList"
            element={
              <ErrorBoundry>
                <PanelAllQrCodeList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/not-initiated-payouts"
            element={
              <ErrorBoundry>
                <NotInitiatedPayment />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/printQr/batch"
            element={
              <ErrorBoundry>
                <QrByBatch />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/printQr/mapping"
            element={
              <ErrorBoundry>
                <QrMapping />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/gift"
            element={
              <ErrorBoundry>
                <GiftList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/gift/add"
            element={
              <ErrorBoundry>
                <AddGift />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/coupon-provider"
            element={
              <ErrorBoundry>
                <ManageCouponProvider />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/static-coupon"
            element={
              <ErrorBoundry>
                <StaticCouponsList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/static-coupon/add"
            element={
              <ErrorBoundry>
                <AddStaticCoupon />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/static-coupon/:brandName"
            element={
              <ErrorBoundry>
                <CouponByBrand />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/redeemed-coupon"
            element={
              <ErrorBoundry>
                <DynamicCouponRequestList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/dynamic-coupon"
            element={
              <ErrorBoundry>
                <OzoneDynamicCouponList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/dynamic-coupon/add"
            element={
              <ErrorBoundry>
                <AddDynamicCoupon />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/gift-catalogue"
            element={
              <ErrorBoundry>
                <GiftCatalogueList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/gift-catalogue/catalogue"
            element={
              <ErrorBoundry>
                <GiftCatalogue />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/gift-catalogue/add"
            element={
              <ErrorBoundry>
                <AddGiftCatalogue />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/points-history"
            element={
              <ErrorBoundry>
                <PointsHistory />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/extra-points-history"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "modenik" ? (
                  <ModenikExtraPoints />
                ) : JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "borosil" ? (
                  <BorosilExtraPoints />
                ) : (
                  <ExtraPointHistory />
                )}
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/redemption-history"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                TenantSlugs.borosil ? (
                  <BorosilRedemptionHistory />
                ) : JSON.parse(sessionStorage.getItem("vendorData"))
                    .tenant_id == TenantSlugs.modenik ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.bch ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.skdreams ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.siyaram ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.cavin ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.bikaji ||
                  JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                  TenantSlugs.century ? (
                  <RedemptionsList />
                ) : (
                  <RedeemRequest />
                )}
              </ErrorBoundry>
              // <ErrorBoundry>
              //   {JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.modenik ||
              //   JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.bch ||
              //   JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.skdreams ||
              //   JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.siyaram ||
              //   JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.cavin ||
              //   JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
              //     TenantSlugs.century ? (
              //     <RedemptionsList />
              //   ) : (
              //     <RedeemRequest />
              //   )}
              // </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/dream-gifts"
            element={
              <ErrorBoundry>
                <DreamGiftsStatus />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/cache-management"
            element={
              <ErrorBoundry>
                <CacheManagement />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/rules"
            element={
              <ErrorBoundry>
                <RulesList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/rules/add"
            element={
              <ErrorBoundry>
                <RuleBuilderPage />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/rules/edit/:id"
            element={
              <ErrorBoundry>
                <RuleBuilderPage />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/rules/view/:id"
            element={
              <ErrorBoundry>
                <ViewRule />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/rules/analytics/:id"
            element={
              <ErrorBoundry>
                <RuleAnalyticsScreen />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/dream-gifts-redemption-history"
            element={
              <ErrorBoundry>
                <DreamGiftsRedeemRequest />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/reports"
            element={
              <ErrorBoundry>
                <IssueReport />
              </ErrorBoundry>
            }
          />
          {/* <Route  exact path="/banner" element={<Banner />} /> */}
          <Route
            exact
            path="/bannerlist"
            element={
              <ErrorBoundry>
                <BannerList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/video"
            element={
              <ErrorBoundry>
                <VideoList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/video/add"
            element={
              <ErrorBoundry>
                <Video />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/gallery"
            element={
              <ErrorBoundry>
                <GalleryList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/media"
            element={
              <ErrorBoundry>
                <Mediaist />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/gallery/add"
            element={
              <ErrorBoundry>
                <Gallery />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/campaign"
            element={
              <ErrorBoundry>
                <Campaign />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/campaign/view"
            element={
              <ErrorBoundry>
                <ViewCampaign />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/campaign/add"
            element={
              <ErrorBoundry>
                <AddCampaign />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/user/:userType"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "borosil" ? (
                  <UserListBorosil />
                ) : (
                  <UserList />
                )}
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/user/:userType/:userName"
            element={
              <ErrorBoundry>
                <UserProfile />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/distributor-wise-scanning"
            element={
              <ErrorBoundry>
                <DistributorWiseScanning />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/distributor-retailer-mapping/:distributorId"
            element={
              <ErrorBoundry>
                <DistributorRetailerMapping />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scanHistory/:userType"
            element={
              <ErrorBoundry>
                <UserScanHistory />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/distinct-scanHistory"
            element={
              <ErrorBoundry>
                <DistinctQrScanHistory />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/fake-reports"
            element={
              <ErrorBoundry>
                <QrReport />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/agriculture/:userType"
            element={
              <ErrorBoundry>
                <AgricultureUsersList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/footwear/:userType"
            element={
              <ErrorBoundry>
                <FootwearUsersList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/hardwar/:userType"
            element={
              <ErrorBoundry>
                <HardwareUsersList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/hoseiry/:userType"
            element={
              <ErrorBoundry>
                <HoseiryUsersList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/user/product"
            element={
              <ErrorBoundry>
                <UserProductMapping />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/brand"
            element={
              <ErrorBoundry>
                <BrandList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/participating-brand"
            element={
              <ErrorBoundry>
                <ParticipatingBrand />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/web-panelUser"
            element={
              <ErrorBoundry>
                <WebPanelUsers />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/web-panelUser/add"
            element={
              <ErrorBoundry>
                <AddWebPanelUser />
              </ErrorBoundry>
            }
          />
          {/* WebPanelUsers */}
          <Route
            exact
            path="/web-panelRole"
            element={
              <ErrorBoundry>
                <WebPanelRoles />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/web-panelRole/add"
            element={
              <ErrorBoundry>
                <EditWebPanelRolePermission />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/e-catalogue"
            element={
              <ErrorBoundry>
                <ECatalogue />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wheel"
            element={
              <ErrorBoundry>
                <Wheel />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wheel-rewards-won"
            element={
              <>
                <WheelRewardsWon />
              </>
            }
          />
          <Route
            exact
            path="/wheelCampaign"
            element={
              <ErrorBoundry>
                <WheelCampaignList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wheelCampaign/add"
            element={
              <ErrorBoundry>
                <Wheel />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/wheel/summary"
            element={
              <ErrorBoundry>
                <WheelSummary />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/e-catalogue/add"
            element={
              <ErrorBoundry>
                <AddECatalogue />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/e-catalogue/edit"
            element={
              <ErrorBoundry>
                <EditECatalogue />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/paymentGateway"
            element={
              <ErrorBoundry>
                <PayementGateway />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/paymentGateway/add"
            element={
              <ErrorBoundry>
                <AddPaymentGateway />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/cashPerPoint"
            element={
              <ErrorBoundry>
                <AppUserType />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/warranty"
            element={
              <ErrorBoundry>
                <WarrantyList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/warranty-claim"
            element={
              <ErrorBoundry>
                <WarrantyClaimList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/warranty-on-products"
            element={
              <ErrorBoundry>
                <WarrantyOnProducts />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/warranty-on-products/add"
            element={
              <ErrorBoundry>
                <AddWarrantyOnProducts />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/sales-booster"
            element={
              <ErrorBoundry>
                <SalesBoosterList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/sales-booster/add"
            element={
              <ErrorBoundry>
                <CreateSalesBooster />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/sales-booster/manage"
            element={
              <ErrorBoundry>
                <ManageSalesBooster />
              </ErrorBoundry>
            }
          />

          {/* Borosil & Generic Sales Booster History */}
          <Route
            exact
            path="/sales-booster/history"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "borosil" ? (
                  <SalesBoosterHistoryBorosil />
                ) : (
                  <SalesBoosterHistory />
                )}
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/product-rank-rules"
            element={
              <ErrorBoundry>
                <BorosilRankRules />
              </ErrorBoundry>
            }
          />
          
          
           <Route
            exact
            path="/iffco-reports"
            element={
              <ErrorBoundry>
                <IffcoReports />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/iffco-expiry-ageing"
            element={
              <ErrorBoundry>
                <IffcoExpiryAgeing />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/iffco-retailer-inventory"
            element={
              <ErrorBoundry>
                <IffcoRetailerInventory />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/iffco-scan-activity-log"
            element={
              <ErrorBoundry>
                <IffcoScanActivityLog />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/iffco-retailer-coverage"
            element={
              <ErrorBoundry>
                <IffcoRetailerCoverage />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/iffco-unscanned-qrs"
            element={
              <ErrorBoundry>
                <IffcoUnscannedQrs />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/refer-and-earn-rewards"
            element={
              <ErrorBoundry>
                <ReferAndEarnRewards />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/refer-and-earn-rewards/add"
            element={
              <ErrorBoundry>
                <AddReferralAndEarnRewards />
              </ErrorBoundry>
            }
          />

          <Route
            path="/refer-user-list"
            element={
              <ErrorBoundry>
                <ReferUser />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/leaderboard"
            element={
              <ErrorBoundry>
                <LeaderBoard />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/sms-credential"
            element={
              <ErrorBoundry>
                <SMSCredential />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/coupon-credential"
            element={
              <ErrorBoundry>
                <CouponCredential />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/coupon-credential/add"
            element={
              <ErrorBoundry>
                <AddCouponCredential />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/sms-credential/add"
            element={
              <ErrorBoundry>
                <AddSMSCredential />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/sms-credential/sms-templates"
            element={
              <ErrorBoundry>
                <SMSTemplates />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/sms-credential/sms-templates/add"
            element={
              <ErrorBoundry>
                <AddSMSTemplates />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/email-credential"
            element={
              <ErrorBoundry>
                <EmailCredentials />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/email-credential/manage"
            element={
              <ErrorBoundry>
                <ManageEmailCredentials />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/email-templates"
            element={
              <ErrorBoundry>
                <EmailTemplates />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/email-templates/manage"
            element={
              <ErrorBoundry>
                <ManageEmailTemplate />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/error-logs"
            element={
              <ErrorBoundry>
                <ErrorLogs />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/whatsapp-notifications"
            element={
              <ErrorBoundry>
                <WhatsappNotificationCredentials />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/whatsapp-notifications/add"
            element={
              <ErrorBoundry>
                <AddWhatsappNotificationCredential />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/whatsapp-notifications/templates"
            element={
              <ErrorBoundry>
                <WhatsappNotificationTemplates />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/whatsapp-notifications/templates/add"
            element={
              <ErrorBoundry>
                <AddWhatappNotificationTemplates />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scheme"
            element={
              <ErrorBoundry>
                <SchemeList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/webFeedback"
            element={
              <ErrorBoundry>
                <WebFeedback />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scheme/manage"
            element={
              <ErrorBoundry>
                <ManageScheme />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scheme/create"
            element={
              <ErrorBoundry>
                <CreateSchemeWizard />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scheme/updateScheme"
            element={
              <ErrorBoundry>
                <CreateSchemeWizard />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scheme/view-stats"
            element={
              <ErrorBoundry>
                <ViewStats />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scheme/details/:schemeId"
            element={
              <ErrorBoundry>
                <SchemeDetailsList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scheme/wallets/:schemeId"
            element={
              <ErrorBoundry>
                <SchemeWalletList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/membership"
            element={
              <ErrorBoundry>
                <MembershipList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/membership/add"
            element={
              <ErrorBoundry>
                <AddMembership />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/membership/history"
            element={
              <ErrorBoundry>
                <MembershipHistory />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/membership/manage"
            element={
              <ErrorBoundry>
                <ManageMembership />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/zones"
            element={
              <ErrorBoundry>
                <Zones />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/zones/add"
            element={
              <ErrorBoundry>
                <AddZones />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/zones/view-locations"
            element={
              <ErrorBoundry>
                <ViewLocations />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/otp"
            element={
              <ErrorBoundry>
                <AppOtps />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scratchable-coupon"
            element={
              <ErrorBoundry>
                <ScratchableSchemeList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scratchable-coupon/add"
            element={
              <ErrorBoundry>
                <AddScaratchableScheme />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scratchable-coupon/rewards"
            element={
              <ErrorBoundry>
                <ScratchableRewardList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scratchable-coupon/rewards/add"
            element={
              <ErrorBoundry>
                <ScratchableRewards />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scratchable-coupon/orders"
            element={
              <ErrorBoundry>
                <SchemePurchaseOrders />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/punch-order"
            element={
              <ErrorBoundry>
                <PurchaseOrderList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/punch-order/add"
            element={
              <ErrorBoundry>
                <ManagePurchaseOrder />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/punch-order/bill"
            element={
              <ErrorBoundry>
                <UpdatePurchaseOrder />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/reward-scheme"
            element={
              <ErrorBoundry>
                <AllRewardSchemeList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/reward-scheme/add"
            element={
              <ErrorBoundry>
                <AddRewardScheme />
              </ErrorBoundry>
            }
          />
          {/* <Route exact path="/reward-scheme/luckydraw" element={ <ErrorBoundry> <LuckyDrawSetup /> </ErrorBoundry>} /> */}

          <Route
            exact
            path="/scheme-order/upload"
            element={
              <ErrorBoundry>
                <SchemeOrderUpload />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/temp"
            element={
              <ErrorBoundry>
                <Temp />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/Logging"
            element={
              <ErrorBoundry>
                <LoggingWhatsappAndSMS />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/qrProductMapping"
            element={
              <ErrorBoundry>
                <QrProductMapping />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/qrMappingToUser"
            element={
              <ErrorBoundry>
                <QrMappingToUser />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/qrProductMappingList"
            element={
              <ErrorBoundry>
                <UpdateQrList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/ban-unban-list"
            element={
              <ErrorBoundry>
                <BanUnban />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/LoggingWhatsapp"
            element={
              <ErrorBoundry>
                <LoggingWhatsapp />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/quiz"
            element={
              <ErrorBoundry>
                <QuizList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/quiz/add"
            element={
              <ErrorBoundry>
                <AddEditQuiz />
              </ErrorBoundry>
            }
          />
          <Route
            path="*"
            element={
              <ErrorBoundry>
                <NotFound />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/scheme-order/upload"
            element={<SchemeOrderUpload />}
          />
          <Route exact path="/legal" element={<LegalList />} />
          <Route exact path="/legal/add" element={<AddLegal />} />

          <Route
            path="/qr-import"
            element={
              <ErrorBoundry>
                <QrBatchImport />
              </ErrorBoundry>
            }
          />

          <Route
            path="/tracking"
            element={
              <ErrorBoundry>
                <Tracking />
              </ErrorBoundry>
            }
          />

          <Route
            path="/appBan"
            element={
              <ErrorBoundry>
                <AppBan />
              </ErrorBoundry>
            }
          />

          <Route
            path="/orders"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "borosil" ? (
                  <BorosilOrderList />
                ) : (
                  <AllOrderList />
                )}
              </ErrorBoundry>
            }
          />

          <Route
            path="/orders/upload"
            element={
              <ErrorBoundry>
                <UploadOrders />
              </ErrorBoundry>
            }
          />

          {/* <Route
            path="/orders/batch"
            element={
              <ErrorBoundry>
                <OrderBatchList />
              </ErrorBoundry>
            }
          /> */}

          <Route
            path="/printer"
            element={
              <ErrorBoundry>
                <PrintersList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/tempelate-printer-mapping"
            element={
              <ErrorBoundry>
                <PrinterTempelateMapping />
              </ErrorBoundry>
            }
          />

          <Route
            path="/printer/"
            element={
              <ErrorBoundry>
                <AddPrinter />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supportQueries"
            element={
              <ErrorBoundry>
                <SupportQueries />
              </ErrorBoundry>
            }
          />

          <Route
            path="/enquiry"
            element={
              <ErrorBoundry>
                <BookAppointment />
              </ErrorBoundry>
            }
          />

          <Route
            path="/bankList"
            element={
              <ErrorBoundry>
                <BankList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/tds"
            element={
              <ErrorBoundry>
                <TDS />
              </ErrorBoundry>
            }
          />

          <Route
            path="/notification"
            element={
              <ErrorBoundry>
                <Notification />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/notification-history"
            element={
              <ErrorBoundry>
                <NotificationHistory />
              </ErrorBoundry>
            }
          />

          <Route
            path="/transaction-list"
            element={
              <ErrorBoundry>
                <CashTransactionList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/cashtransfer-request"
            element={
              <ErrorBoundry>
                <CashTransferRequests key="cashtransfer-request" />
              </ErrorBoundry>
            }
          />

          <Route
            path="/scheme-cashtransfer-request"
            element={
              <ErrorBoundry>
                <CashTransferRequests
                  key="scheme-cashtransfer-request"
                  onlyScheme={true}
                />
              </ErrorBoundry>
            }
          />

          <Route
            path="/coupon-request"
            element={
              <ErrorBoundry>
                <CouponRequests />
              </ErrorBoundry>
            }
          />

          {/* CouponRequests */}
          {/* CouponRequests */}
          <Route
            path="/payment-transfer"
            element={
              <ErrorBoundry>
                <PaymentTransferList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/payment-transfer/batch"
            element={
              <ErrorBoundry>
                <PaymentTransferListByBatchId />
              </ErrorBoundry>
            }
          />

          <Route
            path="/payment-transfer/add"
            element={
              <ErrorBoundry>
                <UploadPaymentTransfer />
              </ErrorBoundry>
            }
          />
          <Route
            path="/payment-target"
            element={
              <ErrorBoundry>
                <PaymentTargetList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/payment-target/batch"
            element={
              <ErrorBoundry>
                <PaymentTargetListByBatchId />
              </ErrorBoundry>
            }
          />

          <Route
            path="/payment-target/add"
            element={
              <ErrorBoundry>
                <UploadPaymentTarget />
              </ErrorBoundry>
            }
          />

          <Route
            path="/faqs"
            element={
              <ErrorBoundry>
                <Faq />
              </ErrorBoundry>
            }
          />

          <Route
            path="/faqs/add"
            element={
              <ErrorBoundry>
                <AddFaq />
              </ErrorBoundry>
            }
          />

          <Route
            path="/faqs/edit/:id"
            element={
              <ErrorBoundry>
                <UpdateFaq />
              </ErrorBoundry>
            }
          />
          <Route
            path="/product-installation-videos"
            element={
              <ErrorBoundry>
                <ProductInstallationVideo />
              </ErrorBoundry>
            }
          />
          <Route
            path="/product-installation-videos/add"
            element={
              <ErrorBoundry>
                <ProductInstallationVideo />
              </ErrorBoundry>
            }
          />

          <Route
            path="/push-notification/"
            element={
              <ErrorBoundry>
                <PushNotificationsTypeList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/push-notification/list"
            element={
              <ErrorBoundry>
                <PushNotificationsDumpList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/push-notification/add"
            element={
              <ErrorBoundry>
                <AddPushNotificationsType />
              </ErrorBoundry>
            }
          />

          <Route
            path="/appFeedback"
            element={
              <ErrorBoundry>
                <AppFeedback />
              </ErrorBoundry>
            }
          />

          <Route
            path="/appProductFeedback"
            element={
              <ErrorBoundry>
                <AppProductFeedBack />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ozone-dynamic-coupons"
            element={
              <ErrorBoundry>
                <OzoneDynamicCouponList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ozone-coupon-request"
            element={
              <ErrorBoundry>
                <DynamicCouponRequestList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/points-retailers"
            element={
              <ErrorBoundry>
                <PointsHistoryRetailers />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/user-roles"
            element={
              <ErrorBoundry>
                <UserRolesSupplyBean />
              </ErrorBoundry>
            }
          />
          <Route
            path="/supply-beam/user-roles/add"
            element={
              <ErrorBoundry>
                <EditUserRolesPermissionSupplyBeam />
              </ErrorBoundry>
            }
          />
          <Route
            path="/supply-beam/users"
            element={
              <ErrorBoundry>
                <SupplyBeamUsers />
              </ErrorBoundry>
            }
          />
          <Route
            path="/supply-beam/users/add"
            element={
              <ErrorBoundry>
                <AddSupplyUsers />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/site-locations/add"
            element={
              <ErrorBoundry>
                <AddSiteLocations />
              </ErrorBoundry>
            }
          />
          <Route
            path="/supply-beam/site-locations"
            element={
              <ErrorBoundry>
                <SiteLocation />
              </ErrorBoundry>
            }
          />

          <Route
            path="/batch-running-code"
            element={
              <ErrorBoundry>
                <SearchByBatchRunningCode />
              </ErrorBoundry>
            }
          />
          <Route
            path="/verification-records"
            element={
              <ErrorBoundry>
                <VerificationRecords />
              </ErrorBoundry>
            }
          />
          <Route
            path="/app-versions"
            element={
              <ErrorBoundry>
                <AppVersion />
              </ErrorBoundry>
            }
          />

          {/* SearchByBatchRunningCode */}
          <Route
            path="/allUsers"
            element={
              <ErrorBoundry>
                <AllUsersList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/century-ledger/:userId"
            element={
              <ErrorBoundry>
                <CenturyLedger />
              </ErrorBoundry>
            }
          />

          <Route
            path="/century-audit-trail"
            element={
              <ErrorBoundry>
                <CenturyAuditTrail />
              </ErrorBoundry>
            }
          />

          <Route
            path="/century-expiry-points"
            element={
              <ErrorBoundry>
                <CenturyExpiryPoints />
              </ErrorBoundry>
            }
          />

          <Route
            path="/pendinglist"
            element={
              <ErrorBoundry>
                <AqualitePendingUser />
              </ErrorBoundry>
            }
          />

          <Route
            path="/salesUsers"
            element={
              <ErrorBoundry>
                <SiyaramSalesUsers />
              </ErrorBoundry>
            }
          />

          <Route
            path="/salesUsers/:empCode"
            element={
              <ErrorBoundry>
                <SiyaramEmpSalesUsers />
              </ErrorBoundry>
            }
          />

          <Route
            path="/product-not-added"
            element={
              <ErrorBoundry>
                <UnEnteredProducts />
              </ErrorBoundry>
            }
          />

          <Route
            path="/manual-rewarding"
            element={
              <ErrorBoundry>
                <ManualRewarding />
              </ErrorBoundry>
            }
          />
          <Route
            path="/order-upload"
            element={
              <ErrorBoundry>
                <OrderUpload />
              </ErrorBoundry>
            }
          />
          <Route
            path="/order-logs"
            element={
              <ErrorBoundry>
                <OrderErrorLogs />
              </ErrorBoundry>
            }
          />
          <Route
            path="/order-list"
            element={
              <ErrorBoundry>
                <OrderList />
              </ErrorBoundry>
            }
          />
          <Route
            path="/order-summary"
            element={
              <ErrorBoundry>
                <OrderSummary />
              </ErrorBoundry>
            }
          />
          <Route
            path="/order-summary/:type/:userId"
            element={
              <ErrorBoundry>
                <OrderDetail />
              </ErrorBoundry>
            }
          />
          <Route
            path="/manual-rewarding/add"
            element={
              <ErrorBoundry>
                <BulkManualRewarding />
              </ErrorBoundry>
            }
          />

          <Route
            path="/bulk-sms"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "borosil" ? (
                  <BorosilBulkSms />
                ) : JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "gautam-garments" ? (
                  <GautamGarmentsBulkSms />
                ) : (
                  <SendBulkMessages />
                )}
              </ErrorBoundry>
            }
          />

          <Route
            path="/request-project-quotation"
            element={
              <ErrorBoundry>
                <RequestProjectQuotation />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ut/:userType"
            element={
              <ErrorBoundry>
                <UltimatrueUserList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ultima-checkout"
            element={
              <ErrorBoundry>
                <UltimatrueSellDetails />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ut/:userType/:userName"
            element={
              <ErrorBoundry>
                <UltimatrueUserProfile />
              </ErrorBoundry>
            }
          />

          <Route
            path="/user-list/:userType"
            element={
              <ErrorBoundry>
                <JqrUserList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/user-list/:userType/:userName"
            element={
              <ErrorBoundry>
                <JqrUserProfile />
              </ErrorBoundry>
            }
          />

          <Route
            path="/mapping"
            element={
              <ErrorBoundry>
                {JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_name === "modenik" ? (
                  <ModenikMapping />
                ) : (
                  <UserMapping />
                )}
              </ErrorBoundry>
            }
          />

          <Route
            path="/topics"
            element={
              <ErrorBoundry>
                <FirebaseTopicsList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/custom-notifications"
            element={
              <ErrorBoundry>
                <CustomNotifications />
              </ErrorBoundry>
            }
          />

          <Route
            path="/bikaji-orders"
            element={
              <ErrorBoundry>
                <BikajiOrderLedger />
              </ErrorBoundry>
            }
          />

          <Route
            path="/upload-orders"
            element={
              <ErrorBoundry>
                <BikajiOrderList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/shelf-orders"
            element={
              <ErrorBoundry>
                <BikajiIShelfList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/cavin-daily"
            element={
              <ErrorBoundry>
                <CavinDailyData />
              </ErrorBoundry>
            }
          />

          <Route
            path="/bch-daily-report"
            element={
              <ErrorBoundry>
                <BchDailyReport />
              </ErrorBoundry>
            }
          />

          <Route
            path="/cavin-monthly"
            element={
              <ErrorBoundry>
                <CavinMonthlyData />
              </ErrorBoundry>
            }
          />

          <Route
            path="/custom-notifications/add"
            element={
              <ErrorBoundry>
                <AddCustomNotifications />
              </ErrorBoundry>
            }
          />

          <Route
            path="/custom-notifications/add"
            element={
              <ErrorBoundry>
                <AddCustomNotifications />
              </ErrorBoundry>
            }
          />

          <Route
            path="/notification-template"
            element={
              <ErrorBoundry>
                <NotificationTemplate />
              </ErrorBoundry>
            }
          />

          <Route
            path="/notification-rule"
            element={
              <ErrorBoundry>
                <NotificationRule />
              </ErrorBoundry>
            }
          />

          <Route
            path="/notification-rule/add"
            element={
              <ErrorBoundry>
                <AddNotificationRule />
              </ErrorBoundry>
            }
          />

          <Route
            path="/account-transfer/add"
            element={
              <ErrorBoundry>
                <AccountTransfer />
              </ErrorBoundry>
            }
          />
          <Route
            path="/account-transfer"
            element={
              <ErrorBoundry>
                <AccountTransferList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/qr-mapping"
            element={
              <ErrorBoundry>
                <QrDistributorMapping />
              </ErrorBoundry>
            }
          />

          <Route
            path="/jqr-point-history"
            element={
              <ErrorBoundry>
                <PointHistoryJqr />
              </ErrorBoundry>
            }
          />

          <Route
            path="/removed-users"
            element={
              <ErrorBoundry>
                <RemovedUsers />
              </ErrorBoundry>
            }
          />

          <Route
            path="/changed-users"
            element={
              <ErrorBoundry>
                <UserTypeChangeList />
              </ErrorBoundry>
            }
          />
          <Route
            path="/tds-redemptions"
            element={
              <ErrorBoundry>
                <TdsOnRedemptions />
              </ErrorBoundry>
            }
          />

          <Route
            path="/gullak-points"
            element={
              <ErrorBoundry>
                <GullakPoints />
              </ErrorBoundry>
            }
          />

          <Route
            path="/gullak-points/add"
            element={
              <ErrorBoundry>
                <GullakPointsUpload />
              </ErrorBoundry>
            }
          />

          <Route
            path="/aqualite-scans"
            element={
              <ErrorBoundry>
                <AppUsersScan />
              </ErrorBoundry>
            }
          />

          <Route
            path="/aqualite-qr-sync"
            element={
              <ErrorBoundry>
                <QrSyncStats />
              </ErrorBoundry>
            }
          />

          <Route
            path="/aqualite-qr-sync/:batch_no"
            element={
              <ErrorBoundry>
                <QrSyncStatsByBatch />
              </ErrorBoundry>
            }
          />

          <Route
            path="/aqualite-invoices"
            element={
              <ErrorBoundry>
                <AqualiteInvoices />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/checkout-list"
            element={
              <ErrorBoundry>
                <CheckoutList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/invoice-list"
            element={
              <ErrorBoundry>
                <InvoiceList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/pick-list"
            element={
              <ErrorBoundry>
                <PicklistList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/order-list"
            element={
              <ErrorBoundry>
                <BontonOrderList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/mapped-list"
            element={
              <ErrorBoundry>
                <MappedList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/demapped-list"
            element={
              <ErrorBoundry>
                <DemappedList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/checkin-list"
            element={
              <ErrorBoundry>
                <CheckinList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/return-list"
            element={
              <ErrorBoundry>
                <ReturnList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/return-info"
            element={
              <ErrorBoundry>
                <ReturnInfo />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/distributor-wise-points"
            element={
              <ErrorBoundry>
                <DistributorWisePointInfo />
              </ErrorBoundry>
            }
          />

          <Route
            path="/supply-beam/qrTracking"
            element={
              <ErrorBoundry>
                <QrTracking />
              </ErrorBoundry>
            }
          />

          <Route
            path="/ut/customer-data/"
            element={
              <ErrorBoundry>
                <CustomerDataList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/reassign"
            element={
              <ErrorBoundry>
                <ReassignWarrantyList />
              </ErrorBoundry>
            }
          />

          {/* UnEnteredProducts */}

          {/* UserMapping */}

          <Route
            exact
            path="/bonus-points"
            element={
              <ErrorBoundry>
                <BulkExtraPoints />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/brsl/point-summary"
            element={
              <ErrorBoundry>
                <UsersPointSummary />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/brsl/monthwise-points"
            element={
              <ErrorBoundry>
                <MonthWisePointSummary />
              </ErrorBoundry>
            }
          />

          <Route
            path="/redemption-list"
            element={
              <ErrorBoundry>
                <RedemptionsList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/vijeta/point-summary"
            element={
              <ErrorBoundry>
                <ModenikPointSummary />
              </ErrorBoundry>
            }
          />

          <Route
            path="/user-search"
            element={
              <ErrorBoundry>
                <BorosilUserHistorySearch />
              </ErrorBoundry>
            }
          />

          <Route
            path="/app-login"
            element={
              <ErrorBoundry>
                <AppLogins />
              </ErrorBoundry>
            }
          />

          <Route
            path="/mandatory-fields"
            element={
              <ErrorBoundry>
                <MandatoryFieldsView />
              </ErrorBoundry>
            }
          />
          <Route
            path="/kyc-update"
            element={
              <ErrorBoundry>
                <KycUpdate />
              </ErrorBoundry>
            }
          />

          <Route
            path="/scheme/tier/:scheme_id"
            element={
              <ErrorBoundry>
                <ManageSchemeTier />
              </ErrorBoundry>
            }
          />

          <Route
            path="/carton-list"
            element={
              <ErrorBoundry>
                <CartonList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/edit-assortment"
            element={
              <ErrorBoundry>
                <EditAssortment />
              </ErrorBoundry>
            }
          />
          <Route
            path="/carton-child"
            element={
              <ErrorBoundry>
                <CartonChildList />
              </ErrorBoundry>
            }
          />
          <Route
            path="/user-activity"
            element={
              <ErrorBoundry>
                <UserLogsList />
              </ErrorBoundry>
            }
          />

          {/* Employee User Route */}
          <Route
            path="/employee-list"
            element={
              <ErrorBoundry>
                <EmployeeList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/employee-level"
            element={
              <ErrorBoundry>
                <EmployeeLevel />
              </ErrorBoundry>
            }
          />

          <Route
            path="/zone-loc"
            element={
              <ErrorBoundry>
                <ZoneLoc />
              </ErrorBoundry>
            }
          />
          <Route
            path="/admin-approval-list"
            element={
              <ErrorBoundry>
                <AdminApprovalList />
              </ErrorBoundry>
            }
          />
          <Route
            path="/approval-list"
            element={
              <ErrorBoundry>
                <ApprovalList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/community"
            element={
              <ErrorBoundry>
                <CommunityList />
              </ErrorBoundry>
            }
          />

          <Route
            path="/zone-pincode"
            element={
              <ErrorBoundry>
                <ZonePincodeMapping />
              </ErrorBoundry>
            }
          />

          <Route
            path="/delete-qr"
            element={
              <ErrorBoundry>
                <DeleteQr />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/pending-scans"
            element={
              <ErrorBoundry>
                <PendingQrs />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/scheme-scanning-history"
            element={
              <ErrorBoundry>
                <SchemeScanningHistory />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/wheel-list"
            element={
              <ErrorBoundry>
                <WheelList />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/user/retailer/scheme/list"
            element={
              <ErrorBoundry>
                <UserTypeSchemeList user_type_id="2" />
              </ErrorBoundry>
            }
          />

          <Route exact path="/temp" element={<Temp />} />

          <Route exact path="/help-and-support" element={<HelpAndSupport />} />

          {/* Ecommerce Product Routes */}
          <Route
            exact
            path="/ecommerce-products"
            element={
              <ErrorBoundry>
                <EcommerceProductList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-products/add"
            element={
              <ErrorBoundry>
                <AddEcommerceProduct />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce/heirarchy"
            element={
              <ErrorBoundry>
                <EcommerceHeirarchy />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-products/edit/:id"
            element={
              <ErrorBoundry>
                <EditEcommerceProduct />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-sizes"
            element={
              <ErrorBoundry>
                <EcommerceSizeMaster />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-colors"
            element={
              <ErrorBoundry>
                <EcommerceColorMaster />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-inventory"
            element={
              <ErrorBoundry>
                <EcommerceInventory />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/ecommerce-orders"
            element={
              <ErrorBoundry>
                <EcommerceOrderList />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-orders/:id"
            element={
              <ErrorBoundry>
                <EcommerceOrderDetail />
              </ErrorBoundry>
            }
          />
          <Route
            exact
            path="/ecommerce-images"
            element={
              <ErrorBoundry>
                <EcommerceImages />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/export-reports"
            element={
              <ErrorBoundry>
                <ExportReports />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/approval-workflow"
            element={
              <ErrorBoundry>
                <ApprovalWorkflow />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/approval-requests"
            element={
              <ErrorBoundry>
                <ApprovalRequests />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/ban-state-at-scanning"
            element={
              <ErrorBoundry>
                <BanStateAtScanning />
              </ErrorBoundry>
            }
          />

          <Route
            exact
            path="/shelf-visibility"
            element={
              <ErrorBoundry>
                <ShelfVisibility />
              </ErrorBoundry>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
    </div>
  );
};

export default TenantHome;
